import { AriaToastRegionProps, useToastRegion } from "@react-aria/toast";
import { ToastState } from "@react-stately/toast";
import {
  Notification,
  NotificationContentType,
  Toast,
  ToastContentType,
} from "ds/ui";
import { useRef } from "react";

type ToastNotificationRegionProps = AriaToastRegionProps & {
  notificationState: ToastState<NotificationContentType>;
  toastState: ToastState<ToastContentType>;
};

export function ToastNotificationRegion({
  notificationState,
  toastState,
  ...props
}: ToastNotificationRegionProps) {
  const toastRegionRef = useRef(null);
  const notificationRegionRef = useRef(null);

  const { regionProps: notificationRegionProps } =
    useToastRegion<NotificationContentType>(
      props,
      notificationState,
      notificationRegionRef,
    );

  const { regionProps: toastRegionProps } = useToastRegion<ToastContentType>(
    props,
    toastState,
    toastRegionRef,
  );

  return (
    <>
      <div
        ref={toastRegionRef}
        {...toastRegionProps}
        className="pointer-events-none fixed bottom-0 left-1/2 z-toast flex w-auto max-w-full -translate-x-1/2 transform flex-col items-center gap-2 p-4"
      >
        {toastState.visibleToasts.map((toast) => {
          return <Toast key={toast.key} state={toastState} toast={toast} />;
        })}
      </div>
      <div
        ref={notificationRegionRef}
        {...notificationRegionProps}
        className="pointer-events-none fixed top-0 right-0 z-toast flex w-auto transform flex-col gap-2 p-4"
      >
        {notificationState.visibleToasts.map((toast) => {
          return (
            <Notification
              key={toast.key}
              state={notificationState}
              toast={toast}
            />
          );
        })}
      </div>
    </>
  );
}
